import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { consumeTheme } from '../../utils/theme';
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, avatar = _a.avatar, description = _a.description, title = _a.title;
            var cls = classNames(prefixCls, className);
            var avatarCls = classNames(prefixCls + "-avatar");
            var contentCls = classNames(prefixCls + "-content");
            var titleCls = classNames(prefixCls + "-title");
            var descriptionCls = classNames(prefixCls + "-description");
            return (h(React.Fragment, null,
                h("div", { className: cls, style: style },
                    avatar &&
                        h("div", { className: avatarCls }, avatar),
                    (title || description) &&
                        h("div", { className: contentCls },
                            title &&
                                h("h4", { className: titleCls }, title),
                            description &&
                                h("div", { className: descriptionCls }, description))),
                children));
        };
        return _this;
    }
    Meta.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Meta;
}(React.Component));
export default Meta;
Meta.defaultProps = {
    prefixCls: 'dui-list-item-meta',
};
Meta.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    avatar: PropTypes.node,
    title: PropTypes.node,
    description: PropTypes.node,
};
